import * as React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  XAxis,
  YAxis,
} from 'recharts';

import { ChartContainer } from './chart';

const chartConfig = {
  age: {
    label: 'Age',
  },
};

export function AgeChart({ ages }: { ages: { age: string; count: number }[] }) {
  return (
    <div className="flex h-full flex-col gap-3 rounded-8 border border-[var(--media-kit-background-alpha)] bg-[var(--media-kit-background-primary)] p-4">
      <h3 className="text-16 font-500 text-[var(--media-kit-text-base)]">
        Age distribution
      </h3>
      <div className="flex size-full items-center gap-4">
        <ChartContainer
          config={chartConfig}
          className="size-full outline-none [&_*]:outline-none"
        >
          <BarChart accessibilityLayer data={ages} margin={{ top: 10 }}>
            <CartesianGrid
              vertical={false}
              stroke="var(--media-kit-background-alpha)"
            />
            <YAxis
              width={24}
              stroke="var(--media-kit-background-alpha)"
              tick={{
                fill: 'var(--media-kit-text-subtle)',
                fontSize: 12,
              }}
            />
            <XAxis
              stroke="var(--media-kit-background-alpha)"
              tick={{
                fill: 'var(--media-kit-text-subtle)',
                fontSize: 12,
              }}
              dataKey="age"
              tickLine={false}
              tickMargin={4}
              axisLine={false}
            />
            <Bar
              dataKey="count"
              fill="var(--media-kit-chart-background-primary)"
              radius={2}
              isAnimationActive={false}
              pointerEvents="none"
            >
              <LabelList
                position="top"
                offset={4}
                className="text-12 text-[var(--media-kit-text-subtle)]"
                formatter={(value: number) => `${value}%`}
              />
            </Bar>
          </BarChart>
        </ChartContainer>
      </div>
    </div>
  );
}
